
export default class Tabs {
  constructor(tabsWrap) {
    this.$tabsWrap    = $(tabsWrap);
    this.tabs         = this.$tabsWrap.find('.tab-nav a');
    this.firstTab     = this.tabs[0];
    this.$tabContent  = $('.brand-content');
    this.ACTIVE_CLASS = 'active';
  }
  removeActiveTabs = () => {
    this.$tabsWrap.find(`.${this.ACTIVE_CLASS}`).removeClass(this.ACTIVE_CLASS);
  };
  handleTabClick = (tab) => {
    const scrollTop = this.$tabContent.offset().top - 100;

    this.removeActiveTabs();
    $(tab).addClass(this.ACTIVE_CLASS);
    $(tab).tab('show');
    if (!$('.node-type-brand').length) {
      $('html, body').animate({ scrollTop: scrollTop }, 'swing');
    } else {
      event.preventDefault();
    }
  };
  attachEventListeners = () => {
    [ ...this.tabs ].forEach((tab) => {
      $(tab).on('click', (event) => {
        this.handleTabClick(tab);
      })
    })
  };
  init = () => {
    $(this.firstTab).addClass(this.ACTIVE_CLASS);
    $(this.firstTab).tab('show');
    this.attachEventListeners();
  };
}



// WEBPACK FOOTER //
// ./js/tabs.js